var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "el-section" }, [
    _c("div", { staticClass: "eu-container" }, [
      _c("div", { staticClass: "eu-flex eu-justify_center" }, [
        _c("div", { staticClass: "eu-flex-item eu-basis_7_md" }, [
          _c(
            "div",
            { staticClass: "emd-container _footer_end _mobile-shift" },
            [
              _vm._m(0),
              _c(
                "div",
                {
                  staticClass:
                    "emd-container__content eu-align_left eu-pt_5_md eu-pb_6_md eu-px_6_md",
                },
                [
                  _c("div", { staticClass: "el-chunk" }, [
                    _c("h2", { staticClass: "emd-text _size_page" }, [
                      _vm._v(
                        _vm._s(_vm.$t("title", { account: _vm.account.name }))
                      ),
                    ]),
                  ]),
                  _c(
                    "p",
                    { staticClass: "emd-text _size_section _type_hint" },
                    [_vm._v(_vm._s(_vm.$t("text")))]
                  ),
                ]
              ),
              _c("div", { staticClass: "emd-container__footer" }, [
                _c(
                  "a",
                  {
                    staticClass: "emd-btn _type_text _color_primary _size_big",
                    attrs: { href: _vm.dashUrl },
                  },
                  [_vm._v(_vm._s(_vm.$t("dashCTA")))]
                ),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "emd-container__header eu-justify_center eu-py_4" },
      [
        _c("span", { staticClass: "emd-text _color_warning" }, [
          _c("i", {
            staticClass: "uil uil-exclamation-triangle",
            staticStyle: { "font-size": "3em" },
          }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }